import { styled } from 'src/ui/theme'

export const Divider = styled.div`
  height: 1px;
  background: ${({ theme }) => theme.colors.gray.bg};
`
